const AGENT_STATUS = {
  AVAILABLE: 'available',
  HALTING: 'halting',
  ONLINE: 'online',
  OFFLINE: 'offline',
};
Object.freeze(AGENT_STATUS);

export default AGENT_STATUS;
